import React, { useRef } from 'react';
import { rawFileToAsset } from '../utils';
import UploadButtonStyle from './style';
const UploadButton = (props) => {
    const { accept, disabled, multiple, setFileList } = props;
    const inputRef = useRef(null);
    const handleFiles = async (files) => {
        const newFiles = [];
        for (let i = 0; i < files.length; i++) {
            const file = files.item(i);
            const newFile = await rawFileToAsset({ rawFile: file });
            newFiles.push(newFile);
        }
        setFileList(newFiles);
    };
    const onChange = () => {
        handleFiles(inputRef.current.files);
    };
    const clickHandler = () => {
        inputRef.current.click();
    };
    const dragOverHandler = (e) => {
        e.preventDefault();
    };
    const onDragEnter = (e) => {
        e.preventDefault();
    };
    const dropHandler = (e) => {
        e.preventDefault();
        if (e?.dataTransfer?.files) {
            handleFiles(e.dataTransfer.files);
        }
    };
    return (React.createElement(UploadButtonStyle, { className: 'upload-wrapper', onDrop: dropHandler, onDragOver: dragOverHandler, onDragEnter: onDragEnter, onClick: clickHandler },
        React.createElement("span", { className: 'upload' },
            React.createElement("input", { style: { display: 'none' }, ref: inputRef, type: 'file', accept: accept, disabled: disabled, multiple: multiple, onClick: (e) => e.stopPropagation(), onChange: onChange }),
            React.createElement("button", { type: 'button' },
                React.createElement("span", null, "x"),
                React.createElement("div", null, "Upload")))));
};
export default UploadButton;
//# sourceMappingURL=index.js.map